import clsx from "clsx";

export type BadgeVariant = "default" | "success" | "warning" | "error";

type BadgeProps = {
    variant?: BadgeVariant;
    children: React.ReactNode;
    className?: string;
};

const Badge = ({ variant = "default", children, className }: BadgeProps) => {
    return (
        <div
            className={clsx(
                "text-sm font-medium py-1 px-4 rounded-md inline",
                variant === "default" && "bg-gray-100",
                variant === "success" && "bg-soft-green-40",
                variant === "warning" && "bg-yellow-300",
                variant === "error" && "bg-red-40 text-white",
                className
            )}
        >
            {children}
        </div>
    );
};

export default Badge;
